export const API = {
  requestOtp: '/auth/register/otp/request',
  submitOtp: '/auth/register/otp/submit',
  keepAlive: '/auth/keep_alive',
  getCategory: '/category?level=1',
  getAllCategory: '/category?level=0',
  registerFactory: '/factory/register',
  registerAgent: '/agent/register',
  masterProvice: '/master/provinces',
  masterDistrict: '/master/districts?province_id=',
  masterSubDistrict: '/master/subdistricts?district_id=',
  masterProperty: '/master/property-labels',
  requestAuthOtp: '/auth/login',
  submitAuthOtp: '/auth/login/confirm',
  authProfile: '/auth/profile',
  getNewOder: '/factory/orders/new_order',
  getDataNewOrder: '/factory/orders/get_data_order',
  getOrderPayment: '/factory/orders/order_payment',
  makeappointment: '/factory/orders/makeappointment',
  getWaitingShip: '/factory/orders/wait_ship',
  getOrderComplete: '/factory/orders/complete',
  getOrderInprocess: '/factory/orders/inprocess',
  getOrderCancel: '/factory/orders/cancel',
  getPendingsku: '/factory/orders/pendingsku',
  getWaitingRefund: '/factory/orders/wait_approve_refund',
  updateApproveRequestCancel: '/factory/orders/update_request_cancel',
  updateDeleteRequestCancel: '/factory/orders/delete_request_cancel',
  createProduct: '/product',
  updateProductSku: '/product/sku/update',
  getProductList: '/factory/products/find',
  deleteProduct: '/product/',
  getProductById: '/product/',
  updateStatusProduct: '/product/updateStatus',
  createAgentByFactory: '/factory/agents/create',
  updateAgentByFactory: '/factory/agents/update',
  createRetailByFactory: '/factory/retails/create',
  updateRetailByFactory: '/factory/retails/update',
  getAgentById: '/factory/agent/',
  getFactoryById: '/factory/',
  getRetailById: '/factory/retail/',
  getAgentsList: '/factory/contacts',
  getContactById: '/factory/contacts/',
  loadAgentContacts: 'factory/load_contacts',
  updateFactory: '/factory/update_factory',
  updateUserProfile: '/factory/update_contact_factory',
  masterZipcode: '/master/sub_districts_id_by_zip_code?zip_code=',
  masterRetailType: '/master/master_by_process/retail_type',
  masterTransportType: '/master/transport_type',
  masterLocationType: '/master/location_type',
  getReportOverview: '/factory/report/overview',
  getReportOverviewCancel: '/factory/report/count_cancel_report',
  getReportOverviewInprogress: '/factory/report/count_inprogress_report',
  getReportOverviewComplete: '/factory/report/count_complete_report',
  getReportOverviewOpen: '/factory/report/count_open_report',
  getReportTopSale: '/factory/report/topsale_report',
  getIncomeChart: '/factory/report/cpmpare_profit_report',
  getNotification: '/push-notification/load_all',
  updateReadNotification: '/push-notification/update_read',
  cancelHandshake: '/factory/cancel_handshake',
  orderProductSku: '/factory/orderproductsku/load_all',
  updateCapacity: '/factory/orderproductsku/create_capacity',
  submitNewOrder: '/factory/orders/submit_order',
  getOrderThaipost: '/factory/orders/data/thaipost',
  getExportOrderToThaiPost: '/factory/orders/data/export_order_thaipost',
  getTokenLine: '/factory/line/load_token',
  updateTokenLine: '/factory/line/add_token',
  testMessageLine: '/factory/line/test_message',
  getOrderproductskuNewOrder: '/factory/orderproductsku/load_order',
  makeOrderConfirm: '/factory/orderproductsku/submit_order_sku',
  getLoadNewOrderSku: '/factory/orderproductsku/load_order_sku',
  createOrderTransaction: '/factory/orderproductsku/create_order_transection',
  rollbackOrderTransaction: '/factory/orderproductsku/rollback_order_transection',
  getOrderDistributed: '/factory/orderproductsku/',
  getOrderDistributedList: '/factory/orderproductsku/order_transaction_list',
  getDetailLotTransaction: '/factory/orderproductsku/order_lot_transection_detail',
  getOlderLotTransaction: '/factory/orderproductsku/order_lot_transection',
  getExportOrderTransafer: '/factory/orders/export_order_tranfer',
  updateOrderComplete: '/factory/orders/update_order_complete',
  getDcAllList: '/dc/load_all',
  deleteUserImmediately: '/factory/delete_agent_user',
  findAgentByTelephone: '/factory/findTelephone/',
  getAgentByTelephone: '/factory/agent/telephone/',
  addAddressData: '/factory/addresses/create',
  updateAddressData: '/factory/addresses/update',
  removeAddressData: '/factory/addresses/remove',
  getBankAdminList: '/bank/bank_factory/get_bank_admin_list',
  getBankInActiveList: '/bank/bank_factory/get_bank_factory_inactive/',
  getBankActiveList: '/bank/bank_factory/get_bank_factory_active/',
  getBankById: '/bank/bank_factory/',
  createBank: '/bank/bank_factory/create_bank_factory',
  updateBank: '/bank/bank_factory/update_bank_factory',
  updateBankStatus: '/bank/bank_factory/update_bank_factory_status',
  deleteBank: '/bank/bank_factory/delete_bank_factory',
  createOrderAdmin: '/factory/orders/create_order_admin',
  updateOrderAdmin: '/factory/orders/update_order_admin',
  confirmManualPayment: '/factory/stock/payment_manual_order',
  confirmManualPaymentBatch: '/factory/stock/payment_manual_order_batch',
  updateManualPayment: '/factory/orders/update_order_payable',
  revertManualOrder: '/factory/orders/revert-cancel',
  increaseQtyInbound: '/product/stock/add_product_inbound',
  getLogoBank: '/master/get_logo_bank',
  getMasterDatasource: '/master/datasource_type',
  getOrderDetail: '/factory/orders/detail',
  getProductSkuList: '/factory/productlist',
  getMasterTransport: '/master/get_master_tarnsport',
  confirmOrderTransport: '/factory/stock/create_transportation',
  masterShippingBand: '/master/master_by_process/shipping_brand',
  createMasterTransport: '/master/create_master_tarnsport',
  updateMasterTransport: '/master/update_master_tarnsport',
  deleteMasterTransport: '/master/delete_master_tarnsport',
  getMasterTransportById: '/master/get_master_tarnsport/',
  prepareShip: '/factory/transport/prepare_ship',
  exportTransportInprocess: '/factory/transport/prepare_ship_export/inprocess',
  getTransportOrderdetail: '/factory/transport/prepare_ship_detail',
  getTransportShipped: '/factory/transport/ship_list',
  getTransportShippedDetail: '/factory/transport/ship_detail',
  exportTransportShipped: '/factory/transport/ship_export/wait_agent_confirm',
  loadTransportationConfigsAll: '/transportation/config/load_all',
  getTransportationType: '/transportation/config/load_transport_type',
  createTransportationConfigs: '/transportation/config/create',
  updateTransportationConfigs: '/transportation/config/update',
  deleteTransportationConfigs: '/transportation/config/delete',
  getTransportationConfigs: '/transportation/config/transport_config_geography',
  getPriceTransportation: '/factory/transport/transport_price',

  // ✅ Api Speed Shipping (Bangbow proxy)
  apiSpeedCheckPrice: '/api-speed-shipping/check-price',
  apiSpeedCheckPriceConfig: '/api-speed-shipping/checkprice-config',

  // ✅ Thailand Post
  tpCheckPrice: '/thailand-post/check-price',

  // ✅ Bangbow setting (master_bangbow)
  bangbowSetting: '/bangbow/setting',
  getTransportationConfigsByAgentId: '/transportation/config/load_agent_transport/',
  createTransportationAgent: '/transportation/config/create_agent_tranfer',
  deleteTransportationAgent: '/transportation/config/delete_agent_tranfer',
  cancelOrder: '/factory/orders/cancel_order',
  getListSendProductExport: '/factory/transport/send_production_export/inprocess',
  findUser: '/factory/user/search',
  masterCancel: '/master/master_by_process/cancel_reason',
  masterGeography: '/master/geography',
  masterBankType: '/master/master_by_process/bank_type',
  loadBankList: '/bank/bank_factory/load_all',
  getAgentBankList: '/bank/bank_factory/agent_in_bank/',
  createAgentBank: '/bank/bank_factory/create_agent_in_bank',
  deleteAgentBank: '/bank/bank_factory/delete_agent_in_bank',
  getAgentBankTypeList: '/bank/bank_factory/agent_in_bankType/',
  createAgentBankType: '/bank/bank_factory/create_agent_in_bankType',
  deleteAgentBankType: '/bank/bank_factory/delete_agent_in_bankType',
  getRetailBankTypeList: '/bank/bank_factory/retail_in_bankType/',
  createRetailBankType: '/bank/bank_factory/create_retail_in_bankType',
  deleteRetailBankType: '/bank/bank_factory/delete_retail_in_bankType',
  refundApprove: 'factory/refund/approve',
  getRepeatOrderRetail: '/factory/orders/last_order',
  getParkingList: '/parking/transport/',
  createParking: '/parking/create',
  updateParking: '/parking/update',
  deleteParking: '/parking/delete',
  getParkingById: '/parking/',
  refundPayment: '/factory/refund/payment',
  masterTagName: '/factory/tagname/tag_lists',
  addTagName: '/factory/tagname/add',
  createTagName: '/factory/tagname/create',
  getDetailRefund: '/factory/refund/detail_payment/',
  updateReadOrder: '/factory/orders/update_read_order',
  loadTaxInvoiceList: '/taxinvoice/load/customer',
  loadTaxInvoiceActive: '/taxinvoice/load/customer/active',
  createTaxInvoice: '/taxinvoice/create',
  deleteTaxInvoice: '/taxinvoice/delete',
  getDeliveryPoint: '/parking/get_all',
  createDeliveryPoint: '/parking/create',
  deleteDeliveryPoint: '/parking/delete',
  updateDeliveryPoint: '/parking/update',
  getTaxInvoiceByOrderId: '/taxinvoice/orders',
  loadTaxInvoiceData: '/taxinvoice/load_all',
  getUserRoleWithoutAdmin: '/user/role_no_systemadmin',
  getUserSystem: '/factory/load_user_factory',
  createUserSystem: '/factory/create_user_factory',
  deleteUserSystem: '/factory/delete_user_factory',
  updateUserSystem: '/factory/update_user_factory',
  getProductNewsList: '/factory/news/find',
  getProductNewsById: '/factory/news/find/',
  updateProductNews: '/factory/news/update',
  createProductNews: '/factory/news/create',
  deleteProductNews: '/factory/news/delete',
  getMasterPoints: '/master/points/get_all',
  createMasterPoint: '/master/points/create',
  updateMasterPoint: '/master/points/update',
  deleteMasterPoint: '/master/points/delete',
  getRequireApprovePoint: '/factory/points/find_all',
  approveRequireApprovePoint: '/factory/points/approve',
  deleteTagName: '/factory/tagname/delete',
  getTransportationTypeByFactory: '/transportation/config/factory_transport_type/',
  addTransportationTypeByFactory: '/transportation/config/add_factory_transport',
  deleteTransportationTypeByFactory: '/transportation/config/delete_factory_transport',
  masterBoxSize: '/master/master_by_process/box_size',
  createMasterData: '/master/create_master_data',
  deleteMasterData: '/master/delete_master_data/',
  updateMasterData: '/master/update_master_data',
  getParkingTransportProvinceType: '/parking/transport_type/province',
  getParkingTransportDistrictType: '/parking/transport_type/district',
  getParkingTransportType: '/parking/transport_type',
  getOrderBangbowByFactory: '/factory/report/order_by_factory',
  getOrderInProgress: '/factory/report/order_in_progress',
  getOrderPendingPayment: '/factory/report/order_pending_payment',
  getOrderPendingPaymentSummary: '/factory/report/order_pending_payment_summary',
  getOrderInProgressSummary: '/factory/report/order_in_progress_summary',
  getOrderItemCompleteReport: '/factory/report/order_item_complete',
  payoutPendingSummary: '/factory/report/payout/pending-summary',
  payoutCreate: '/factory/report/payout/create',
  payoutList: '/factory/report/payout/list',
  payoutBatchSummary: '/factory/report/payout/batch-summary',
  payoutItems: '/factory/report/payout',
  uploadFile: '/files/upload',
  uploadImage: '/images/upload',
  getParkingTransportAreaType: '/parking/transport_type/area',
  getFactoryByAdmin: '/factory/admin/factory_by_admin',

  // MasterBoxes endpoints (New System)
  masterBoxes: '/master/boxes',
  masterBoxesGetAll: '/master/boxes/getAll',
  masterBoxesGetById: '/master/boxes',
  masterBoxesUpdate: '/master/boxes/update',
  masterBoxesDelete: '/master/boxes/delete',

  // Master SKU Tags (Global tag/badge สำหรับ SKU เช่น sale_channel: wholesale/retail)
  masterSkuTagGetAll: '/master/sku-tags/getAll',

  authLoginPassword: '/auth/login_user',
  changePasswordUserSystem: '/user/admin/change_password',
  forgotPassword: '/auth/forgot_password/request',
  resetPassword: '/auth/forgot_password/set_password',
  // Order Prepare Ship (Phase 1)
  checkSpeedMerchantStatus: '/factory/orders/check_speed_merchant_status',
  checkThailandPostMerchantStatus: '/factory/orders/check_thailand_post_merchant_status',
  checkShippingItems: '/factory/orders/check_shipping_items',
  apiSpeedCreateShipment: '/factory/orders/create_speed_shipment',
  retryShipment: '/factory/orders/retry_shipment',
  apiCreateShippingQueue: '/factory/orders/shipping/queue',
  apiGetShippingQueueStatus: '/factory/orders/shipping/queue-status',
  apiGetAlternativeCarriers: '/factory/orders/shipping/alternatives',
  apiGetShippingItems: '/factory/orders/shipping/items',
  triggerShippingCron: '/factory/orders/shipping/trigger-cron',
  saveSelfTracking: '/factory/orders/shipping/save-self-tracking',
  // บันทึกเลขพัสดุจริงของรายการ "ส่งเอง" ระดับ retail_order_item (ไม่ต้องเรียกขนส่งก่อน)
  saveSelfTrackingByItem: '/order-tracks/self-tracking',
  getTpLabel: '/factory/orders/shipping/tp-label',

  // ส่งพัสดุ standalone (Speed)
  factoryParcelCreate: '/factory/orders/parcel/create',
  factoryParcelAddressByPhone: '/factory/orders/parcel/address-by-phone',
  factoryParcelList: '/factory/orders/parcel/list',
  factoryParcelDetail: (id: string) => `/factory/orders/parcel/detail/${id}`,
  factoryParcelPrint: '/factory/orders/parcel/print',
  factoryParcelMarkPrint: '/factory/orders/parcel/mark-print',
  factoryParcelCancel: (tracking: string) => `/factory/orders/parcel/cancel/${encodeURIComponent(tracking)}`,
  factoryParcelRetry: (id: string) => `/factory/orders/parcel/${encodeURIComponent(id)}/retry`,
  factoryParcelTriggerCron: '/factory/orders/parcel/trigger-cron',
  factoryCreditBalance: '/factory/orders/credit/balance',
  factoryCreditTransactions: '/factory/orders/credit/transactions',
  factoryCodCreditInfo: '/factory/orders/credit/cod-info',
  factoryCreditActiveLots: '/factory/orders/credit/active-lots',
  factoryCreditPackages: '/factory/orders/credit/packages',
  factoryCreditTopupInitiate: '/factory/orders/credit/topup/initiate',
  factoryCreditTopupStatus: (orderCode: string) =>
    `/factory/orders/credit/topup/${encodeURIComponent(orderCode)}/status`,
  factoryCreditTopups: '/factory/orders/credit/topups',

  // Order Tracks — โหลดรายการ Track การจัดส่ง / อัปเดตพิมพ์ / Transport Brands
  getOrderTracks: '/order-tracks/load-all',
  updateTrackingPrint: '/order-tracks/update-print',
  getTransportBrands: '/order-tracks/transport-brands',
  // MasterPackagingType
  masterPackagingType: '/master/packaging-types/getAll',
  masterPackagingTypeById: '/master/packaging-types',
  masterProductUnit: '/master/master_by_process/product_unit',

  verifyRegistrationToken: '/auth/register/verify-token',
  setInitialPassword: '/auth/register/set-initial-password',
  resendVerifyEmail: '/auth/register/resend-verify-email',

  // ✅ Manage Merchant (Factory — ตั้งค่าที่อยู่รับสินค้า)
  getMerchantList: (factory_id: string) => `/factory/${factory_id}/speed-merchant`,
  replaceDefaultMerchant: (factory_id: string) => `/factory/${factory_id}/speed-merchant/replace-default`,
  getTpMerchantList: (factory_id: string) => `/factory/${factory_id}/thaipost-merchant`,
  createMerchantPair: (factory_id: string) => `/factory/${factory_id}/merchant/create-pair`,

  // ✅ Stock Management — เปิด/ปิดระบบจัดการสต็อกของ SKU
  toggleSkuStock: '/product/stock/toggle-sku-stock',
  batchToggleSkuStock: '/product/stock/batch-toggle-sku-stock',
  adjustSkuStock: '/product/stock/adjust-sku-stock',
  skuStockTransactions: '/product/stock/sku-stock-transactions',
  upsertSafeStock: '/product/stock/safe-stock/upsert',
  getSafeStock: '/product/stock/safe-stock/get',
  deleteSafeStock: '/product/stock/safe-stock/delete',

  // ✅ General Stock — สต็อกทั่วไป (CRUD)
  generalStockCreate: '/product/stock/general/create',
  generalStockGet: '/product/stock/general/get',
  generalStockUpdate: '/product/stock/general/update',
  generalStockDelete: '/product/stock/general/delete',
  generalStockList: '/product/stock/general/list',
  generalStockAdjust: '/product/stock/general/adjust',
  generalStockTransactions: '/product/stock/general/transactions',
  skuStockList: '/product/stock/sku/list',
  stockPickerList: '/product/stock/picker/list',

  // ✅ Product Recipe
  recipeList: '/product/recipe/list',
  recipeGet: '/product/recipe/get',
  recipeCreate: '/product/recipe/create',
  recipeUpdate: '/product/recipe/update',
  recipeDelete: '/product/recipe/delete',

  // ✅ SKU linked stock (read-only รอบแรก)
  linkedStockList: '/product/linked-stock/list',
  linkedStockSync: '/product/linked-stock/sync',

  // ✅ Inventory by Factory — ดึงสินค้าทั้งหมดของโรงงาน พร้อมข้อมูล SKU + stock
  getInventoryByFactory: (factory_id: string) => `/product/inventory/${factory_id}`,

  // ✅ Parcel Customers — Tab「ลูกค้าส่งพัสดุนอก SKU」ใน ManageAgent
  factoryParcelCustomers: '/factory/orders/parcel/customers',
  factoryParcelCustomerAddresses: '/factory/orders/parcel/customer/addresses',
  factoryParcelCustomerParcels: '/factory/orders/parcel/customer/parcels',
  factoryParcelAddressUpdate: (id: string) => `/factory/orders/parcel/address/${id}`,
  factoryParcelAddressDelete: (id: string) => `/factory/orders/parcel/address/${id}`,

  // ✅ Event Calendar (อบรม) — ผู้ประกอบการดูหลักสูตร / จองรอบ
  factoryEventCalendarFind: '/factory/event-calendar/find',
  factoryEventCalendarById: '/factory/event-calendar/find/',
  factoryEventCalendarRounds: (event_id: string) => `/factory/event-calendar/rounds/${event_id}`,
  factoryEventCalendarRegister: (event_id: string) => `/factory/event-calendar/register/${event_id}`,
  factoryEventCalendarCancel: '/factory/event-calendar/cancel',
  factoryEventCalendarMyBookings: '/factory/event-calendar/my-bookings',
  /** คำเชิญอบรมที่ยังรอตอบ — ของใบสมัคร (ลีด) ที่ร้านนี้โตมา · ร้านที่ไม่ได้มาจากลีดได้ [] */
  factoryEventCalendarInvitations: '/factory/event-calendar/invitations',

  // ✅ Factory Contact Activity — บันทึกการติดต่อ (Contact Note) ใน ManageAgent
  factoryContactActivityCreate: '/factory-contact-activity/create',
  factoryContactActivityLoadAll: '/factory-contact-activity/load-all',
  factoryContactActivityLoad: (id: string) => `/factory-contact-activity/load/${id}`,
  factoryContactActivityUpdate: '/factory-contact-activity/update',
  factoryContactActivityDelete: '/factory-contact-activity/delete',

  // ✅ Seller Dashboard (ภาพรวมร้านค้า) — /factory/seller-report/*
  sellerReportKpi: '/factory/seller-report/kpi',
  sellerReportTodoSummary: '/factory/seller-report/todo-summary',
  sellerReportSalesTrend: '/factory/seller-report/sales-trend',
  sellerReportOrderStatus: '/factory/seller-report/order-status',
  sellerReportTopProducts: '/factory/seller-report/top-products',
  sellerReportCustomerBase: '/factory/seller-report/customer-base',
  sellerReportFinanceSummary: '/factory/seller-report/finance-summary',
}